import { useTranslation } from '@web_opxp/features';
import * as React from 'react';
import { getDomainIconSrc } from '../../assets';

interface ICFQResultCardProps {
  domainId: number;
  value: number;
}

export default function CFQResultCard({ domainId, value }: Readonly<ICFQResultCardProps>) {
  const { t } = useTranslation();

  const domainIcon = getDomainIconSrc(domainId);
  const domainTitle = t(`common:Domain.Title.${domainId}`);
  const percentage = value / 100;
  const handlePosition = `${percentage}%`;
  const style = { '--handle-pos': handlePosition } as React.CSSProperties;
  return (
    <div className="cfq-domain-evaluation-card">
      <div className="card-head">
        <img src={domainIcon} alt={domainTitle} />
        <span>{domainTitle}</span>
      </div>
      <div className="domain-evaluation-bar" style={style}>
        <svg
          className="handle"
          width="16"
          height="43"
          viewBox="0 0 16 43"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <line x1="8" y1="7" x2="8" y2="43" stroke="#2990D9" strokeWidth="2" />
          <path
            d="M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8Z"
            fill="white"
            stroke="#2A92D9"
            strokeWidth="4"
          />
        </svg>
      </div>
      <div className="evaluation-bar-labels">
        <span>{t('CFQ.Questionnaire.Answers.VeryOften')}</span>
        <span>{t('CFQ.Questionnaire.Answers.Never')}</span>
      </div>
    </div>
  );
}
